// REACT_APP_BASE_URL in .env drives API target (restart dev server after .env changes).
const baseUrl = (process.env.REACT_APP_BASE_URL || 'http://localhost:4000').replace(/\/+$/, '');

export const api = `${baseUrl}/api`;
export const profile = `${baseUrl}/`;
export const SOCKET_URL = `${baseUrl}/`;

export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY || '';
